import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

export async function submitPIF({ fundId, streamId, companyDetails, responses, attachments, dealId, reopenToken }) {
  const fn = httpsCallable(functions, 'submitPIF');
  // dealId + reopenToken are sent ONLY on the analyst-issued reopen/correction
  // flow; when absent they are undefined (dropped by the callable), so a normal
  // submission's payload is unchanged.
  const result = await fn({ fundId, streamId, companyDetails, responses, attachments, dealId, reopenToken });
  return result.data;
}

export async function generateAISummary({ dealId, pifSubmissionId }) {
  const fn = httpsCallable(functions, 'generateAISummary');
  const result = await fn({ dealId, pifSubmissionId });
  return result.data;
}

export async function generateReopenToken({ dealId, reason }) {
  const fn = httpsCallable(functions, 'generateReopenToken');
  const result = await fn({ dealId, reason });
  return result.data;
}

export async function validateReopenToken(token) {
  const fn = httpsCallable(functions, 'validateReopenToken');
  const result = await fn({ token });
  return result.data;
}

// Public (no-auth) prefill payload for the reopen form. Server re-validates the
// token and returns only company-facing fields + previous responses, so the
// public reopen page never needs an auth-gated client-SDK read.
export async function getReopenPrefillData(token) {
  const fn = httpsCallable(functions, 'getReopenPrefillData');
  const result = await fn({ token });
  return result.data;
}

export async function sendCompanyNotification({ dealId, notificationType, additionalData }) {
  const fn = httpsCallable(functions, 'sendCompanyNotification');
  const result = await fn({ dealId, notificationType, additionalData });
  return result.data;
}

export async function sendInternalNotification({ recipientIds, subject, body, dealId }) {
  const fn = httpsCallable(functions, 'sendInternalNotification');
  const result = await fn({ recipientIds, subject, body, dealId });
  return result.data;
}

// Encode a browser File object as base64 for sending to Cloud Functions
export async function encodeFileForUpload(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({
      name: file.name,
      type: file.type,
      size: file.size,
      data: reader.result.split(',')[1],
    });
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
